import qs from "query-string";
import type { NavigateFunction } from "react-router-dom";

// @eslint-ignore
export const parseRouteParams = <T>(search: string): T => (search ? (qs.parse(search) as unknown as T) : ({} as T));

export const createRouteSearch = (params: object): string => "?" + qs.stringify(params);

export const updateRouteParams = (
  navigate: NavigateFunction,
  pathname: string,
  params: object,
  state: object,
): void => {
  const search = createRouteSearch(params);

  navigate({ pathname, search }, { state });
};

export const urlReplace = (str: string, data: object): string => {
  if (!str) {
    return "";
  }
  Object.entries(data).forEach(([key, value]) => (str = str.replace(`:${key}`, String(value))));
  return str;
};
